import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';
const ssoHost = publicConfig.external_address;

export const Fees = {
  createVatAddress: (accessToken, ssoId, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/${ssoId}/VAT`,
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, payload);
  },
  updateVatAddress: (accessToken, ssoId, feeProfileId, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/update/${ssoId}/${feeProfileId}`,
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, payload);
  },
  createAddress: (accessToken, ssoId, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/${ssoId}`,
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, payload);
  },

  fetchAddress: (accessToken, ssoId, type, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/${ssoId}/${type}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, null);
  },

  updateAddress: (accessToken, feeProfileId, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/${feeProfileId}`,
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, payload);
  },

  fetchAllFeeProfiles: (accessToken, ssoId, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/${ssoId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, null);
  },

  fetchRegionalFees: (accessToken, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: '/v1/fees/types/regional',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, payload);
  },

  deactivateVatProfile: (accessToken, ssoId, feeProfileId, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/deactivate/${ssoId}/${feeProfileId}/vat`,
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, null);
  },

  fetchAddressById: (accessToken, feeProfileId, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/fees/profiles/profile/${feeProfileId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, (response) => {
      callback(response);
    }, null);
  }
};
